import React, { useState, useRef, useEffect } from 'react'
import { Box, Divider } from '@mui/material'
import PromptStarter from './PromptStarter/PromptStarter'
import styles from './Landing.module.css'
import { useAuth } from '../../Context/AuthContext'
import NewProjectModal from './NewProjectModal/NewProjectModal'
import PreviousProjects from './PreviousProjects/PreviousProjects'
import { getProjects } from '../../api'
import config from '../../config'

const { homepageUIFlag } = config

const promptStarters = [
  {
    iconSrc: '/images/icons/snowflake.svg',
    text: 'New Layout'
  },
  {
    iconSrc: '/images/icons/restart-icon-green.svg',
    text: 'Continue Last'
  },
  {
    iconSrc: '/images/icons/book.svg',
    text: 'Upload Assets'
  },
  {
    iconSrc: '/images/icons/settings.svg',
    text: 'Adjust Guidelines & Rules'
  }
]

export default function Landing ({ setCurrentView, threadId }) {
  const ref = useRef(null)
  const { currentUser } = useAuth()
  const givenName = currentUser?.givenName
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [search, setSearch] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [projects, setProjects] = useState([])
  const [displayProjects, setDisplayProjects] = useState(false)

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true)
      try {
        const res = await getProjects()
        setProjects(res)
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
      }
    }
    fetchProjects()
  }, [])

  const filteredProjects = projects.filter(project =>
    project?.project_name.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <>
      <Box
        className={styles.landingContainer}
        sx={{
          width: { xs: '100%', sm: '90%', md: '80%', lg: '65%', xl: '50%' },
          padding: {
            xs: homepageUIFlag ? '0 10px 10px 10px' : '10px',
            md: homepageUIFlag ? '0 20px 20px 20px' : '20px',
            lg: homepageUIFlag ? '0 30px 30px 30px' : '30px'
          },
          margin: '0 auto',
          gap: homepageUIFlag && { sm: '20px', md: '20px', lg: '30px' },
          justifyContent: homepageUIFlag && 'flex-start'
        }}
      >
        <Box
          className={styles.searchContainer}
          ref={ref}
          sx={
            displayProjects
              ? {
                  backgroundColor: '#f5f8fa',
                  borderRadius: '15px 15px 5px 5px !important'
                }
              : {}
          }
        >
          <Box
            sx={{
              marginTop: displayProjects ? 0 : '160px !important'
            }}
            className={
              displayProjects ? styles.activeSearchbar : styles.searchbar
            }
          >
            <img
              src='/images/icons/search-icon.svg'
              alt='search'
              className={styles.searchIcon}
            />
            <input
              type='text'
              className={styles.searchInput}
              placeholder='Search Previous Projects'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onMouseDown={() => setDisplayProjects(true)}
            />
          </Box>
          {displayProjects && (
            <PreviousProjects
              open={displayProjects}
              setOpen={setDisplayProjects}
              projects={filteredProjects}
              loading={loading}
              error={error}
            />
          )}
        </Box>
        <p className={styles.greeting}>{`Hello, ${givenName}`}</p>
        <Box
          className={styles.welcomeText}
          sx={{
            gap: homepageUIFlag && { sm: '20px', md: '24px', lg: '32px' }
          }}
        >
          <p>Welcome to Project ECCO,</p>
          <p>
            A communication tool for accelerating design estimations within the
            Blue Sky process.
          </p>
        </Box>
        <Divider sx={{ backgroundColor: '#DCE2E5', height: '1px' }} />
        <Box className={styles.starters}>
          <Box className={styles.promptStarters}>
            {promptStarters.map((promptStarter, index) => {
              return (
                <PromptStarter
                  key={index}
                  iconSrc={promptStarter.iconSrc}
                  text={promptStarter.text}
                  selected={index === 0}
                  onClick={() => {
                    index === 0 && setOpenModal(true)
                  }}
                />
              )
            })}
          </Box>
        </Box>
      </Box>
      <NewProjectModal
        open={openModal}
        setOpen={setOpenModal}
        setCurrentView={setCurrentView}
        threadId={threadId}
      />
    </>
  )
}
